import { useEffect, useState } from 'react';
import { Space, Tag } from '@arco-design/web-react';
import { customersApi } from '@/api';
import { formatMoney } from '@/utils/money';
import type { CustomerListResult } from '@/api';

export default function DashboardView() {
  const [data, setData] = useState<CustomerListResult | null>(null);

  useEffect(() => {
    customersApi.list({ page: 1, pageSize: 1 }).then(setData).catch(() => null);
  }, []);

  return (
    <div className="admin-page">
      <div className="admin-page__header">
        <div>
          <div className="admin-page__title">工作台</div>
          <div className="admin-page__subtitle">客户资金总览与系统状态</div>
        </div>
        <Tag color="arcoblue">实时数据</Tag>
      </div>

      <div className="admin-stat-grid">
        <div className="admin-stat">
          <div className="admin-stat__label">客户总数</div>
          <div className="admin-stat__value">{data?.total ?? '-'}</div>
        </div>
        <div className="admin-stat">
          <div className="admin-stat__label">管理员母账户余额</div>
          <div className="admin-stat__value">
            {data && data.masterBalanceCents !== null
              ? formatMoney(data.masterBalanceCents)
              : '—'}
          </div>
          {data && data.masterBalanceCents === null && (
            <div style={{ color: 'var(--admin-danger)', fontSize: 12 }}>
              未初始化，请执行 seed_admin_master
            </div>
          )}
        </div>
        <div className="admin-stat">
          <div className="admin-stat__label">全部客户钱包余额合计</div>
          <div className="admin-stat__value">
            {data ? formatMoney(data.totalWalletBalanceCents) : '-'}
          </div>
        </div>
      </div>

      <div className="admin-card" style={{ marginTop: 16 }}>
        <Space direction="vertical" size={8}>
          <strong>提示</strong>
          <span style={{ color: 'var(--admin-text-secondary)' }}>
            · 客户余额明细与转账请进入「客户中心」。
          </span>
          <span style={{ color: 'var(--admin-text-secondary)' }}>
            · 卡片冻结请进入「卡片管理」；上游通道异步通知请查看「Webhook 收件箱」。
          </span>
          <span style={{ color: 'var(--admin-text-secondary)' }}>
            · 所有写操作（转账、改密、冻卡、查看敏感字段）均会写入审计日志。
          </span>
        </Space>
      </div>
    </div>
  );
}
